module.exports = __webpack_public_path__ + "static/media/pic1@2x.8baf9885.png";